module.exports = __webpack_public_path__ + "img/melilla.33c4f851.svg";